import type { CoachmarkStep } from '../components/DriverCoachmark';

export const HOME_PAGE_STEPS_INTERNAL: CoachmarkStep[] = [
  {
    targetSelector: '[data-tour="notifications"]',
    title: 'Bildirimler',
    description: 'Yeni teklif, atama ve güncellemeler burada görünür. Kırmızı nokta okunmamış bildirimi gösterir.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="profile-button"]',
    title: 'Profilim',
    description: 'Kişisel bilgiler, belgeler, bildirim ve güvenlik ayarlarına buradan ulaşabilirsiniz.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="driver-status"]',
    title: 'Sürücü Durumu',
    description: 'Boş/Dolu durumunuzu buradan değiştirin. "Boş" ken yeni teklif alabilirsiniz.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="stats-cards"]',
    title: 'İstatistik Kartları',
    description: 'Kabul bekleyen, aktif ve tamamlanan işlerinizin sayısını gösterir.',
    placement: 'top',
  },
  {
    targetSelector: '[data-tour="active-shipments"]',
    title: 'Aktif Sevkiyatlar',
    description: 'Devam eden sevkiyatlar. "Süreci Aç ve İlerle" ile adımları takip edin.',
    placement: 'top',
  },
  {
    targetSelector: '[data-tour="quick-links"]',
    title: 'Hızlı Erişim',
    description: 'Yardım ve Destek Merkezi ile masraf/izin işlemlerinize hızlıca ulaşın.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="bottom-nav"]',
    title: 'Alt Gezinme Menüsü',
    description: 'Ana Sayfa, Sevkiyatlar, Muhasebe, Belgeler, Destek ve Profil arasında geçiş yapın.',
    placement: 'top',
  },
];

export const HOME_PAGE_STEPS_EXTERNAL: CoachmarkStep[] = [
  {
    targetSelector: '[data-tour="notifications"]',
    title: 'Bildirimler',
    description: 'Yeni teklif, atama ve güncellemeler burada görünür. Kırmızı nokta okunmamış bildirimi gösterir.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="profile-button"]',
    title: 'Profilim',
    description: 'Kişisel bilgiler, belgeler, bildirim ve güvenlik ayarlarına buradan ulaşabilirsiniz.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="stats-cards"]',
    title: 'İstatistik Kartları',
    description: 'Aktif sevkiyat, fatura bekleyen ve ödeme bekleyen işlemlerinizi gösterir.',
    placement: 'top',
  },
  {
    targetSelector: '[data-tour="external-earnings"]',
    title: 'Aylık Kazanç',
    description: 'Bu ayki toplam kazancınızı ve tamamlanan taşıma sayısını görün.',
    placement: 'top',
  },
  {
    targetSelector: '[data-tour="offers-section"]',
    title: 'Teklifler',
    description: 'Size gelen teklifleri görüntüleyin, değerlendirin ve teklif verin.',
    placement: 'top',
  },
  {
    targetSelector: '[data-tour="quick-links"]',
    title: 'Hızlı Erişim',
    description: 'Yardım ve Destek Merkezi\'ne buradan ulaşabilirsiniz.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="bottom-nav"]',
    title: 'Alt Gezinme Menüsü',
    description: 'Ana Sayfa, Panels, Muhasebe, Belgeler, Destek ve Profil arasında geçiş yapın.',
    placement: 'top',
  },
];

export const ASSIGNMENTS_PAGE_STEPS_INTERNAL: CoachmarkStep[] = [
  {
    targetSelector: '[data-tour="pending-tasks"]',
    title: 'Kabul Bekleyen Görevler',
    description: 'Onay bekleyen görevler. Detayları görüp onaylayabilirsiniz.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="active-assignments"]',
    title: 'Atanan Sevkiyatlar',
    description: 'Onayladığınız sevkiyatları açıp süreç adımlarını takip edin.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="past-shipments"]',
    title: 'Geçmiş Sevkiyatlar',
    description: 'Tamamlanan sevkiyatları görüntüleyin.',
    placement: 'top',
  },
];

export const SHIPMENT_DETAIL_PAGE_STEPS_INTERNAL: CoachmarkStep[] = [
  {
    targetSelector: '[data-tour="tracking-action-panel"]',
    title: 'İşlem Paneli',
    description: 'Sevkiyatı yönetmek için tüm aksiyonlar burada: onayla, tahliye bildir, evrak yükle ve tamamla.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="tracking-documents"]',
    title: 'Belgeler',
    description: 'Yükleme, teslim ve fatura evraklarını buradan görüntüleyin. Her belge türü için ayrı bölümler mevcut.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="tracking-unload-report"]',
    title: 'Tahliye Bildirme',
    description: 'Boşaltma sorunu veya gecikme durumunda bu butonu kullanarak operasyon ekibine bildirim gönderin.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="tracking-complete"]',
    title: 'Sevki Tamamla',
    description: 'Teslim evraklarını yükleyip sevkiyatı tamamlayın. Kamera ile çekim veya galeriden dosya seçimi yapabilirsiniz.',
    placement: 'bottom',
  },
];

export const SHIPMENT_DETAIL_PAGE_STEPS_EXTERNAL: CoachmarkStep[] = [
  {
    targetSelector: '[data-tour="tracking-action-panel"]',
    title: 'İşlem Paneli',
    description: 'Sevkiyatı yönetmek için tüm aksiyonlar burada: onayla, tahliye bildir, evrak yükle ve tamamla.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="tracking-documents"]',
    title: 'Belgeler',
    description: 'Yükleme, teslim ve fatura evraklarını buradan görüntüleyin. Her belge türü için ayrı bölümler mevcut.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="tracking-extra-expenses"]',
    title: 'Ek Masraflar',
    description: 'Bekleme ve hammaliye bedeli gibi ek masrafları buradan girin. Sevkiyat tamamlarken muhasebeye aktarılır.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="tracking-unload-report"]',
    title: 'Tahliye Bildirme',
    description: 'Boşaltma sorunu veya gecikme durumunda bu butonu kullanarak operasyon ekibine bildirim gönderin.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="tracking-complete"]',
    title: 'Sevki Tamamla',
    description: 'Teslim evraklarını yükleyip fatura bilgisiyle birlikte sevkiyatı tamamlayın.',
    placement: 'bottom',
  },
];

export const ASSIGNMENTS_PAGE_STEPS_EXTERNAL: CoachmarkStep[] = [
  {
    targetSelector: '[data-tour="pending-tasks"]',
    title: 'Kabul Bekleyen Görevler',
    description: 'Onay bekleyen görevler. Kabul edebilir veya reddedebilirsiniz.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="active-assignments"]',
    title: 'Atanan Sevkiyatlar',
    description: 'Onayladığınız sevkiyatları açıp süreç adımlarını takip edin.',
    placement: 'bottom',
  },
  {
    targetSelector: '[data-tour="past-shipments"]',
    title: 'Geçmiş Sevkiyatlar',
    description: 'Tamamlanan sevkiyatları görüntüleyin.',
    placement: 'top',
  },
];
